var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_c('v-progress-linear',{attrs:{"color":"green","indeterminate":true}}):_c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.invitations,"items-per-page":-1,"dense":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }